// Authors: Delaney Gillilan
// Icon: tabler:box
// Slug: Create a scope for scoped signals
// Description: This attribute creates a scoped object in signals for scoping data to specific DOM elements.

import type { AttributePlugin } from '../../../engine/types'
import { modifyScope } from '../../../utils/text'

let scopedCounter = 0

export const Scoped: AttributePlugin = {
  type: 'attribute',
  name: 'scoped',
  keyReq: 'denied',
  onLoad: ({ el, value, mods, merge }) => {
    let scopedKey =
      value ||
      `_${el.closest('[id]')?.id || crypto.randomUUID()}${scopedCounter++}`

    if (el.parentElement) {
      scopedKey = modifyScope(scopedKey, el.parentElement, mods)
    }

    // Create the scoped object in signals
    merge({ [scopedKey]: {} })

    // Return cleanup function that removes the scope
    return () => {
      merge({ [scopedKey]: null })
    }
  },
}
